<template>
    <div class="flex-page-sidebar">
        <nav class="nav-secondary">
            <div class="dropdown">
                <a class="btn dropdown-toggle" href role="button" id="navSecondaryMenuBtn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static">
                    Show: {{ activeTitle }}
                </a>
                <div class="dropdown-menu" aria-labelledby="navSecondaryMenuBtn">
                    <template v-if="navOptionSections">
                        <template v-for="navOptionSection in navOptionSections">
                            <div v-if="navOptionSection.divider" class="dropdown-divider"></div>
                            <h6 v-if="navOptionSection.title" class="ml-2 mt-2 mb-hf">{{ navOptionSection.title }}</h6>
                            <div v-for="o in navOptionSection.options">
                                <router-link :to="{name: o.value}" class="dropdown-item" :class="{'active': activeRoute == o.value}" :id="`navSecondary-${o.value}`">
                                    {{ o.text }}
                                    <span v-if="o.badge" class="nav-secondary-badge ml-hf">{{ o.badge }}</span>
                                </router-link>
                            </div>
                        </template>
                    </template>
                    <template v-else-if="navOptions">
                        <div v-for="o in navOptions">
                            <router-link :to="{name: o.value}" class="dropdown-item" :class="{'active': activeRoute == o.value}" :id="`navSecondary-${o.value}`">
                                {{ o.text }}
                                <span v-if="o.badge" class="nav-secondary-badge ml-hf">{{ o.badge }}</span>
                            </router-link>
                        </div>
                    </template>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    computed: {
        activeRoute() {
            if (this.navOptionSections) {
                for (let sec of this.navOptionSections) {
                    for (let opt of sec.options) {
                        if (this.$route.matched.find(r => r.name === opt.value)) {
                            return opt.value
                        }
                    }
                }
            } else if (this.navOptions) {
                for (let opt of this.navOptions) {
                    if (this.$route.matched.find(r => r.name === opt.value)) {
                        return opt.value
                    }
                }
            }
            return ''
        },
        activeTitle() {
            if (this.useOptionTextAsTitle) {
                if (this.navOptionSections) {
                    for (let sec of this.navOptionSections) {
                        for (let opt of sec.options) {
                            if (this.$route.matched.find(r => r.name == opt.value)) {
                                return opt.text
                            }
                        }
                    }
                } else if (this.navOptions) {
                    for (let opt of this.navOptions) {
                        if (this.$route.matched.find(r => r.name == opt.value)) {
                            return opt.text
                        }
                    }
                }
                return ''
            }
            return this.$store.state.pageTitle
        }
    },
    props: ['navOptions', 'navOptionSections', 'useOptionTextAsTitle'],
}
</script>

<style scoped>
.nav-secondary-badge {
    display: inline-block;
    min-width: 1.25rem;
    padding: 0.125rem 0.375rem;
    border-radius: 0.625rem;
    background-color: #FE4E00; /* $brand-orange */
    color: #fff;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1;
    text-align: center;
}
</style>
